// extracted by mini-css-extract-plugin
export default {"wrapper":"AccountDeletion_wrapper__9m5wS","active":"AccountDeletion_active__DiTCT","dangerInput":"AccountDeletion_dangerInput__Xc7E7"};